/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getSiteVisitStatuses = ({ params } = {}) => axios.get(`site_visit_statuses`, { params });